import { schema } from "normalizr";

export const socialAccountProfile = new schema.Entity(
    "socialAccountProfile",
    {},
    { idAttribute: "social_account_id" }
);
